import React, { useEffect, useState } from 'react';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import ResetPasswordForm from './ResetPasswordForm';
import { postValidateResetToken } from '../src/authApis';
import { useDict, useLanguageUpdate } from '../../../contexts/LanguageContext';
import LoadingSpinner from '../../../components/LoadingSpinner';
import CustomSwitch from '../../../components/CustomSwitch';

const ResetPassword = () => {
    const dict = useDict();
    const toggleLanguage = useLanguageUpdate();
    const [language, setLanguage] = useState(localStorage.getItem('language') === 'th');

    const handleChange = (checked) => {
        setLanguage(checked);
        toggleLanguage(checked ? 'th' : 'en');
    };

    const [resetToken, setResetToken] = useState('');
    const [email, setEmail] = useState('');
    const [isValidResetToken, setIsValidResetToken] = useState();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);

        const urlEmail = queryParams.get('email');
        const urlResetToken = queryParams.get('token');

        if (!urlEmail || !urlResetToken) {
            setIsValidResetToken(false);
            return;
        };

        setResetToken(urlResetToken);
        setEmail(urlEmail);

        const values = {
            email: urlEmail,
            token: urlResetToken
        };

        postValidateResetToken(values, handlePostValidateResetToken, handlePostValidateResetTokenError);
    }, []);

    const handlePostValidateResetToken = (response) => {
        setIsValidResetToken(response);
    }

    const handlePostValidateResetTokenError = (error) => {
        setIsValidResetToken(false);
    }

    return (
        <>
            {isLoading && <LoadingSpinner />}
            <div className="account account--photo">
                <div className="account__wrapper">
                    <div className="account__card">
                        <div>
                            <div className="text-right">
                                <CustomSwitch
                                    checked={language}
                                    onChange={handleChange}
                                    width={65}
                                    height={35}
                                    className="language-switch"
                                    leftText="EN"
                                    rightText="TH"
                                    switchOffClassName="switch-off"
                                    switchOnClassName="switch-on"
                                />
                            </div>
                            <h3 className="account__title">
                                <span className="account__logo">
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className="auth-logo"
                                    />
                                </span>
                            </h3>
                        </div>
                        {
                            !isValidResetToken ?
                                <div className="text-align-center mt-5 mb-5">
                                    <h4>{dict.resetPasswordLinkExpired}</h4>
                                </div>

                                :

                                <ResetPasswordForm
                                    token={resetToken}
                                    email={email}
                                    setIsLoading={setIsLoading}
                                />
                        }
                        <div className="account__or_divide">
                            <div className="regulated-by-text">
                                {dict.regulatedByText}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
